import React from 'react';
import { getJsonPath } from '../../utils/constants';

type Props = {};

const SplashScreenContainer = (props: Props) => {
    console.log(props);
    return (
        <div className="splashScreenContainer">
            <div className="container">
                <div className="logo">
                    <img
                        src={getJsonPath('/SplashScreen/nuacare_logo.svg')}
                        height={400}
                        width={400}
                        alt=""
                    />
                </div>
                <div>
                    <img
                        className="left side"
                        height={400}
                        width={400}
                        src={getJsonPath('/SplashScreen/nuacare_left.svg')}
                        alt=""
                    />
                    <img
                        className="cross"
                        height={400}
                        width={400}
                        src={getJsonPath('/SplashScreen/nuacare_center.svg')}
                        alt=""
                    />
                    <img
                        className="right side"
                        height={400}
                        width={400}
                        src={getJsonPath('/SplashScreen/nuacare_right.svg')}
                        alt=""
                    />
                </div>
            </div>
        </div>
    );
};

export default SplashScreenContainer;
